module.exports = __webpack_public_path__ + "static/grafika5@2x-48763da491c3c1d7f331e63b5e0e22ea.png";